import React from 'react';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Checkbox } from '../ui/checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const COST_OPTIONS = ["Free", "Sliding scale", "Insurance required", "Fee-based"];
const SERVICE_MODALITIES = ["In-person", "Phone", "Virtual", "Mobile / Outreach"];
const POPULATIONS = [
  "Adults", "Children", "Seniors", "Families", "Pregnant Women", "Veterans",
  "Immigrants/Refugees", "LGBTQ+", "Homeless", "Low Income", "Uninsured", "Disabled"
];

const EligibilitySection = ({ formData, onChange, onMultiSelect }) => (
  <Card className="rounded-2xl border-[#E0D6C8]">
    <CardHeader className="pb-4">
      <CardTitle className="text-lg font-['Manrope']">Eligibility & Access</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label>Populations Served</Label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2">
          {POPULATIONS.map(pop => (
            <div key={pop} className="flex items-center space-x-2">
              <Checkbox id={`pop-${pop}`} data-testid={`population-${pop}`} checked={formData.populations_served?.includes(pop)} onCheckedChange={(checked) => onMultiSelect('populations_served', pop, checked)} />
              <label htmlFor={`pop-${pop}`} className="text-sm text-[#5A5A5A]">{pop}</label>
            </div>
          ))}
        </div>
      </div>
      <div>
        <Label>Eligibility Requirements</Label>
        <Textarea data-testid="eligibility-input" placeholder="e.g., Must be a resident of Boston, income below 200% FPL" value={formData.eligibility_requirements} onChange={(e) => onChange('eligibility_requirements', e.target.value)} className="rounded-xl mt-1.5" />
      </div>
      <div>
        <Label>Cost to Client</Label>
        <Select value={formData.cost_to_client} onValueChange={(v) => onChange('cost_to_client', v)}>
          <SelectTrigger data-testid="cost-select" className="rounded-xl mt-1.5"><SelectValue /></SelectTrigger>
          <SelectContent>{COST_OPTIONS.map(cost => (<SelectItem key={cost} value={cost}>{cost}</SelectItem>))}</SelectContent>
        </Select>
      </div>
      <div>
        <Label>Service Modality</Label>
        <div className="grid grid-cols-2 gap-2 mt-2">
          {SERVICE_MODALITIES.map(mod => (
            <div key={mod} className="flex items-center space-x-2">
              <Checkbox id={`mod-${mod}`} data-testid={`modality-${mod}`} checked={formData.service_modality?.includes(mod)} onCheckedChange={(checked) => onMultiSelect('service_modality', mod, checked)} />
              <label htmlFor={`mod-${mod}`} className="text-sm text-[#5A5A5A]">{mod}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center space-x-3">
          <Checkbox id="referral" data-testid="referral-checkbox" checked={formData.referral_required} onCheckedChange={(checked) => onChange('referral_required', checked)} />
          <label htmlFor="referral" className="text-sm font-medium text-[#1A1A1A]">Referral Required</label>
        </div>
        <div className="flex items-center space-x-3">
          <Checkbox id="handoff" data-testid="handoff-checkbox" checked={formData.warm_handoff_possible} onCheckedChange={(checked) => onChange('warm_handoff_possible', checked)} />
          <label htmlFor="handoff" className="text-sm font-medium text-[#1A1A1A]">Warm Handoff Possible</label>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default EligibilitySection;
